import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';
dayjs.extend(relativeTime); // 相对时间
dayjs.locale('zh-cn'); // 使用本地化语言

export const RandomLetter = (length: number) => {
  let result: string[] = [];
  // eslint-disable-next-line array-callback-return
  [...new Array(length).keys()].map(() => {
    let ranNum = Math.ceil(Math.random() * 25);
    result.push(String.fromCharCode(65 + ranNum));
  })
  return result.join('');
}
/*
 * @param time 时间字符串
 * @param friendly 显示xxx时间前 (显示为几分钟前 几小时前 几天前 几个月前 )
 */
export function getLastTimeStr(time: string, friendly: boolean) {
  if (friendly) {
    return dayjs(time).fromNow().replace(' ', '');
  }
  return dayjs(new Date(time)).format('YYYY-MM-DD HH:mm');
}

export const timeFormatter = (timestamp: number) => {
  timestamp /= 1000

  const seconds = Math.trunc(timestamp % 60)
  const minutes = Math.trunc(timestamp / 60 % 60)
  const hours = Math.trunc(timestamp / 60 / 60 % 60)

  return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
}

export const formatTime=(seconds: number, format: string = "min-s"): string=> {
  let minutes: number = Math.floor(seconds / 60);
  seconds = seconds % 60;
  if (format === "min-s") {
    if (minutes > 0) {
      return `${minutes}min${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  } else if (format === "h-m-s") {
    let hours: number = Math.floor(minutes / 60);
    minutes = minutes % 60;
    if (hours > 0) {
      return `${hours}h${minutes}min${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}min${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  } else {
    throw new Error("Invalid format specified");
  }
}

export const getDateRangeString=(): string => {
  const lastWeekStart = dayjs().subtract(1, 'week').startOf('week');
  const lastWeekEnd = dayjs().subtract(1, 'week').endOf('week');
  const startDateStr = lastWeekStart.format('YYYY.MM.DD');
  const endDateStr = lastWeekEnd.format('YYYY.MM.DD');
  return `${startDateStr}～${endDateStr}`;
}

export function weightFormatter(num: number) {
  if (num < 1000) {
    return [num, 'g']
  }

  if (num < 1000000) {
    return [(Number(num) / 1000).toFixed(2), 'kg']
  }

  return [(Number(num) / 1000000).toFixed(2), 't']
}
